import React, { useState } from "react";
import Grid from "@mui/material/GridLegacy";
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Select from '@mui/material/Select';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';
import {Control, UseFormRegister} from "react-hook-form/dist/types/form";
import {FieldErrors} from "react-hook-form/dist/types/errors";
import {Controller } from "react-hook-form";
import {IPharmacyType} from "../../../../queries/pharmacy/pharmacyModel";
import {FormControl, Typography} from "@mui/material";
import {additionalQuestions} from "../../../../constants/signupQuestions";

interface QuestionProps {
  item: any;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  control: Control<any>;
}

const Question: React.FunctionComponent<QuestionProps> = ({
  item,
  register,
  errors,
  control,
}) => {
  const [answer, setAnswer] = useState<any>('');

  const onChangeHandler = (event: any) => {
    setAnswer(event.target.value);
  };

  return (
    <React.Fragment>
      <Grid item xs={12} sm={12} md={12}>
        <Typography component="h1" variant="h6">{item.question}</Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <Controller
          name={item.name}
          control={control}
          defaultValue=''
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel id="hearAboutUs-label">Select</InputLabel>
              <Select
                {...field}
                labelId="hearAboutUs-label"
                id={item.name}
                label="Select2"
                fullWidth
                required
                {...register(item.name)}
                value={answer}
                onChange={onChangeHandler}
                error={!!errors[item.name]}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
              >
                {item.options.map((option: any) => (
                  <MenuItem key={option.key} value={option.key}>{option.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
      </Grid>
      { !!item.options.find((option: any) => option.key === answer)?.additionalField && (
        <Grid item xs={12} sm={6} md={6}>
          <TextField
            label={item.options.find((option: any) => option.key === answer)?.additionalField}
            id={`${item.name}-additionalAnswer`}
            fullWidth
            required
            helperText={errors.hearAboutUsDetails?.message?.toString()}
            {...register(`${item.name}-additionalAnswer`)}
            error={!!errors.hearAboutUsDetails}
          />
        </Grid>
      )}
    </React.Fragment>
  )
}

export default Question;